import { render } from "./UpdateArtistModal.vue?vue&type=template&id=29d0c12d&scoped=true"
import script from "./UpdateArtistModal.vue?vue&type=script&lang=js"
export * from "./UpdateArtistModal.vue?vue&type=script&lang=js"

import "./UpdateArtistModal.vue?vue&type=style&index=0&id=29d0c12d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d0c12d"]])

export default __exports__